
import Scheduler from "@/components/Scheduler";
import { ViewType } from "@/components/Scheduler";
import { Navigate, useParams } from "react-router-dom";
import { useDoctorOnlyMode } from "@/hooks/useDoctorOnlyMode";

interface IndexProps {
  view?: ViewType;
}

const Index = ({ view }: IndexProps) => {
  const { tab } = useParams<{ tab?: string }>();
  // Doctor-only logins (roadmap #11) never see the full dashboard: every
  // Index-served view (scheduler, referrals, inventory, tasks, admin,
  // report) redirects them to their own My Patients page.
  const { doctorOnly, isLoading } = useDoctorOnlyMode();
  if (isLoading) return null;
  if (doctorOnly) return <Navigate to="/my-patients" replace />;
  return <Scheduler initialView={view} initialTab={tab} />;
};

export default Index;
